var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSacolinha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping-bag-one (\xE8\xB4\xAD\xE7\x89\xA9\xE8\xA2\x8B1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.875 7.5H8.125C7.08947 7.5 6.25 8.33947 6.25 9.375V24.375C6.25 25.4105 7.08947 26.25 8.125 26.25H21.875C22.9105 26.25 23.75 25.4105 23.75 24.375V9.375C23.75 8.33947 22.9105 7.5 21.875 7.5Z",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.75 11.25V6.25C18.75 4.17893 17.0711 2.5 15 2.5C12.9289 2.5 11.25 4.17893 11.25 6.25V11.25",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacolinha);
export default __webpack_public_path__ + "static/media/sacolinha.205d134f56ef81fd15832ee0f4a76fcb.svg";
export { ForwardRef as ReactComponent };